import { Component, OnInit } from '@angular/core';

import { Router,ActivatedRoute , ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;


@Component({
  selector: 'app-account-order-tracking-page',
  templateUrl: './account-order-tracking-page.component.html',
  styleUrls: ['./account-order-tracking-page.component.css']
})
export class AccountOrderTrackingPageComponent implements OnInit {
  
  pageName = "Order Tracking";

  modelData;
  orderRef = "";
  orderStatus = ""
  userId
  status = 1
  collection = false;
  statusDescription = "PROCESSING"
  backOrderId 

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private route: ActivatedRoute,
    private _ecomm: CommerceDataService
  ) { }

  ngOnInit() {

     $('#initialise-page').trigger('click');
     
     this.userId = sessionStorage.getItem('context')

      if(!this.userId) {
          $('#loader').hide();
          // redirect to login 
          this.router.navigate(['/account/login']);
      }
      
      let backOrder = this.route.snapshot.paramMap.get('id');

      this.getBackOrderDetails(backOrder)
  }

  getBackOrderDetails(backOrder) {
    let queryData = new FormData();
    queryData.append('modelName', 'BackOrder');
    queryData.append('mid', backOrder);
    queryData.append('context_id', this.userId);


      $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          if(data['covers'] != undefined && data['covers'].length > 0) {
            this.modelData = data['covers'][0]['cover']['model']['modelData'];
            this.orderStatus = this.modelData['systemManagedEntities']['orderDetails']['status'];
            let orderId = this.modelData['systemManagedEntities']['orderDetails']['orderId'];
            this.orderRef = this.modelData['systemManagedEntities']['orderDetails']['refNumber'];

            this.statusCheckConfig(this.orderStatus)
            this.backOrderId = data['covers'][0]['id'];
          }
          
        },
        error => {

            $('#loader').hide();

        },

        () => {
          $('#loader').hide();
          // this.reviewOrderSummary()
        }
      );
  }

  statusCheckConfig(status) {
    switch (status) {
      
      case 'PROCESSING':
          this.status = 2
          this.statusDescription = "PROCESSING"
        break;

      case 'PACKED':
          this.status = 2
          this.statusDescription = "PROCESSING"
        break;

      case 'QUALITY_CHECK':
          this.status = 3
          this.statusDescription = "QUALITY CHECK"
        break;

      case 'DISPATCHED':
          this.status = 4
          this.statusDescription = "DISPATCHED"
        break;

      case 'READYFORCOLLECTION':
          this.status = 4
          this.statusDescription = "READY FOR COLLECTION"
        break;

      case 'DELIVERED':
          this.status = 5
          this.statusDescription = "DELIVERED"
        break;
    
      default:
        break;
    }
  }

}




